import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import variableStyles from '../../styles/variables.module.css.js';

const Variant3PathwayIllustration = /*#__PURE__*/ forwardRef(({ color = variableStyles.black, width = '100%' }, ref)=>jsx("svg", {
        width: width,
        viewBox: "0 0 865 838",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: jsx("path", {
            ref: ref,
            d: "M563.313 50.96C541.779 191.464 520.156 333.086 526.589 475.065C528.6 519.606 533.603 564.862 551.92 605.517C570.193 646.172 603.655 681.957 646.677 693.573C692.157 705.858 744.293 687.541 772.126 649.567C828.328 572.815 772.037 486.68 690.37 464.611C584.98 436.108 469.315 483.642 378.624 533.768C265.282 596.403 161.054 675.479 70.095 767.644",
            stroke: color,
            strokeWidth: "140",
            strokeMiterlimit: "10",
            strokeLinecap: "round"
        })
    }));

export { Variant3PathwayIllustration as default };
